'use client';

import Title from '~/components/utils/Title';
import { DumpJSON, UnderConstruction } from '~/features/dev';
import type { next } from '~/modules';

/** @TODO(V1): finish this error page */
export default function _Error(props: next.ErrorProps) {
    // Let Next.js handle 404s
    if (props.error.message === 'NEXT_NOT_FOUND') {
        throw props.error;
    }

    return (
        <div className="flex flex-col justify-center py-6 lg:py-12">
            <div className="max-w-full flex-col gap-4">
                <span className="mb-2 block text-4xl font-extrabold text-secondary">Woops</span>
                <Title size="6xl" className="mb-6">
                    Something went wrong
                </Title>
                <DumpJSON json={props.error} />
                <UnderConstruction />
            </div>
        </div>
    );
}
